
import { CmhFilesState } from '@/store/new-connection-cmh/cmh-files/types';
import { RootState } from '@/store/types';
import { ActionTree } from 'vuex';

export const actions: ActionTree<CmhFilesState, RootState> = {}
